"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Siemens = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var electric_potential_1 = require("./electric-potential");
/**
 * The derived unit for electric conductance ( <code>S</code> ).
 * One Siemens is equal to one ampere per volt.
 * It is named after the German engineer Ernst Werner von Siemens (1816-1892).
 */
exports.Siemens = UnitDivide.electricalCurrentByElectricalPotential("Siemens", uom_1.BaseUnits.Ampere, electric_potential_1.Volt);
//# sourceMappingURL=electric-conductance.js.map